import { useEffect } from "react";
// react-i8next
import { useTranslation } from "react-i18next";
// @Mui
import { enUS, arEG } from "@mui/material/locale";
// recoil
import { useRecoilState } from "recoil";
// theme
import { themeAtom } from "src/recoil";
// config
import { allLangs, defaultLang } from "src/config";

// ----------------------------------------------------------------------

export default function useLocales() {
  const { i18n, t: translate } = useTranslation();

  const [theme, setTheme] = useRecoilState(themeAtom);

  const langStorage =
    typeof window !== "undefined" ? localStorage.getItem("i18nextLng") : "";

  const currentLang =
    allLangs.find((_lang) => _lang.value === langStorage) || defaultLang;

  const handleChangeLanguage = (newlang) => {
    i18n.changeLanguage(newlang);
    setTheme({ ...theme, dir: newlang === "en" ? "ltr" : "rtl" });
    document.dir = newlang === "en" ? "ltr" : "rtl";
  };

  useEffect(() => {
    if (theme.dir === "rtl") {
      i18n.changeLanguage("ar");
    } else {
      i18n.changeLanguage("en");
    }
  }, []);

  return {
    onChangeLang: handleChangeLanguage,
    translate: (text, options) => translate(text, options),
    currentLang,
    allLangs,
  };
}
